import React, { useState, useMemo, useRef, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FilterBarContainer,
    FilterBarLeftContent,
    FilterBarRightContent,
} from "./FilterBar.styled";
import { Select, Button, TextField, SwitchMode } from "@ann/web-components";

const FilterBar = ({ mode, setMode }) => {
    const navigate = useNavigate();
    const [selectedOwner, setSelectedOwner] = useState([]);
    const [selectedLastUpdate, setSelectedLastUpdate] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [filtersKey, setFiltersKey] = useState(0);
    const [searchTermLastUpdate, setSearchTermLastUpdate] = useState("");
    const [selectedType, setSelectedType] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const searchTimeoutRef = useRef(null);

    const typeOptions = [
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
        { label: "Draft", value: "draft" },
        { label: "Archived", value: "archived" },
    ];

    const categoryOptions = [
        { label: "GPT-4", value: "gpt-4" },
        { label: "GPT-4 Turbo", value: "gpt-4-turbo" },
        { label: "GPT-3.5", value: "gpt-3.5" },
        { label: "Claude 2", value: "claude-2" },
    ];

    const lastUpdateOptions = [
        { label: "Last 7 days", value: "last_7_days" },
        { label: "Last 30 days", value: "last_30_days" },
        { label: "This year", value: "this_year" },
    ];

    const ownerOptions = [
        { label: "John Doe", value: "john_doe" },
        { label: "Jane Smith", value: "jane_smith" },
        { label: "Mike Johnson", value: "mike_johnson" },
    ];

    const filteredLastUpdate = useMemo(() => {
        if (!searchTermLastUpdate.trim()) return lastUpdateOptions;
        const searchLower = searchTermLastUpdate.toLowerCase();
        return lastUpdateOptions.filter(
            (option) =>
                option.label.toLowerCase().includes(searchLower) ||
                option.value.toLowerCase().includes(searchLower)
        );
    }, [searchTermLastUpdate]);



    const handleMultipleSelectionLastUpdate = (items) => {
        setSelectedLastUpdate(items);
    };

    const handleMultipleSelectionCategory = (items) => {
        setSelectedCategory(items);
    };

    const handleMultipleSelectionType = (items) => {
        setSelectedType(items);
    };

    const handleMultipleSelectionOwner = (items) => {
        setSelectedOwner(items);
    };

    const handleSearchChange = useCallback((value) => {
        setSearchValue(value);
        
        // Clear existing timeout
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        
        // Set new timeout for 500ms debounce
        searchTimeoutRef.current = setTimeout(() => {
            // TODO: Add search callback here if needed
        }, 500);
    }, []);

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);

    const handleClearAllFilters = () => {
        setSelectedType([]);
        setSelectedCategory([]);
        setSelectedOwner([]);
        setSelectedLastUpdate([]);
        setSearchTermLastUpdate("");
        setSearchValue("");
        setFiltersKey((prev) => prev + 1);
        
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
    };

    const emptyOrValue = (arr) => (arr.length > 0 ? arr : undefined);

    return (
        <FilterBarContainer>
            <FilterBarLeftContent>
                <TextField
                    iconLeft="search"
                    onChange={handleSearchChange}
                    size="small"
                    placeholder="Search"
                    value={searchValue}
                />
                <Select
                    key={`status-filter-${filtersKey}`}
                    label="Type"
                    onSelectionChange={handleMultipleSelectionType}
                    placeholder="Type"
                    size="small"
                    value={emptyOrValue(selectedType)}
                    width="auto"
                    minWidth="60px"
                >
                    <Select.Menu>
                        {typeOptions.map((type) => (
                            <Select.Item
                                key={type.value}
                                value={type.value}
                                label={type.label}
                            >
                                {type.label}
                            </Select.Item>
                        ))}
                    </Select.Menu>
                </Select>
                <Select
                    key={`model-filter-${filtersKey}`}
                    label="Category"
                    placeholder="Category"
                    onSelectionChange={handleMultipleSelectionCategory}
                    size="small"
                    value={emptyOrValue(selectedCategory)}
                    width="auto"
                    minWidth="60px"
                >
                    <Select.Menu>
                        {categoryOptions.map((category) => (
                            <Select.Item
                                key={category.value}
                                value={category.value}
                                label={category.label}
                            >
                                {category.label}
                            </Select.Item>
                        ))}
                    </Select.Menu>
                </Select>
                <Select
                    key={`owner-filter-${filtersKey}`}
                    label="Owner"
                    placeholder="Owner"
                    onSelectionChange={handleMultipleSelectionOwner}
                    size="small"
                    value={emptyOrValue(selectedOwner)}
                    width="auto"
                    minWidth="60px"
                >
                    <Select.Menu>
                        {ownerOptions.map((owner) => (
                            <Select.Item
                                key={owner.value}
                                value={owner.value}
                                label={owner.label}
                            >
                                {owner.label}
                            </Select.Item>
                        ))}
                    </Select.Menu>
                </Select>
                <Select
                    key={`last-update-filter-${filtersKey}`}
                    label="Last Update"
                    placeholder="Last Update"
                    onSelectionChange={handleMultipleSelectionLastUpdate}
                    size="small"
                    value={emptyOrValue(selectedLastUpdate)}
                    width="auto"
                    minWidth="60px"
                >
                    <Select.Menu>
                        {filteredLastUpdate.map((option) => (
                            <Select.Item
                                key={option.value}
                                value={option.value}
                                label={option.label}
                            >
                                {option.label}
                            </Select.Item>
                        ))}
                    </Select.Menu>
                </Select>

                <Button
                    icon=""
                    iconLeft=""
                    iconRight=""
                    label="Clear Filters"
                    size="medium"
                    type="secondary"
                    onClick={handleClearAllFilters}
                />
            </FilterBarLeftContent>
            <FilterBarRightContent>
                {/* <SwitchMode
                    mode={mode}
                    onModeChange={setMode}
                /> */}
            </FilterBarRightContent>
        </FilterBarContainer>
    );
};

export default FilterBar;
